import { toast, type ExternalToast } from 'sonner';

/**
 * Fire-and-forget log of a client-side error to SystemLog (visible in admin/logs).
 */
function logError(message: string) {
  fetch('/api/log/page-view', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      event: 'client_error',
      entityType: 'error',
      description: message.slice(0, 500),
      url: typeof window !== 'undefined'
        ? window.location.pathname + window.location.search
        : undefined,
    }),
    keepalive: true,
  }).catch(() => {});
}

/**
 * Drop-in replacement for `toast.error()` that also logs the error to SystemLog.
 * Use this instead of `toast.error()` anywhere a user-visible error is shown.
 */
function error(message: string, options?: ExternalToast) {
  logError(message);
  return toast.error(message, options);
}

export const loggedToast = { error, logError };
